/**
 * Molecules/DynamicTextOnlyHero: use Dynamic text only hero for content that warrants the highest level of prominence but doesn’t require imagery
 *
 * @module views/components/DynamicTextOnlyHero
 * @memberof -Common
 */
import './DynamicTextOnlyHero.scss';

import React from 'react';

import PropTypes from 'prop-types';

import TextOnlyHero from '../TextOnlyHero/TextOnlyHero';

/**
 * Represents a DynamicTextOnlyHero component
 *
 * @method
 * @param {DynamicTextOnlyHeroProps} props - React properties passed from composition
 * @returns DynamicTextOnlyHero
 */
export const DynamicTextOnlyHero = function( props ){
  const { backgroundColor, image, tag, eyebrow, headline, headlineTag, headlineHighlight, headlineHighlightColor, subheadline, actionGroup } = props;
  if( !image && !tag && !eyebrow && !headline && !headlineTag && !headlineHighlight && !headlineHighlightColor && !subheadline ){
    return null;
  }

  return (
    <div className='DynamicTextOnlyHero'>
      <TextOnlyHero
        backgroundColor={ backgroundColor }
        image={ image }
        tag={ tag }
        eyebrow={ eyebrow }
        headline={ headline }
        headlineTag={ headlineTag }
        headlineHighlight={ headlineHighlight }
        headlineHighlightColor={ headlineHighlightColor }
        subheadline={ subheadline }
        subheadlineStyle='subtitle-2'
        headlineStyle='title-5'
        actionGroup={ actionGroup }
      />
    </div>
  );
};

/**
 * Property type definitions
 * @typedef DynamicTextOnlyHeroProps
 * @type {object}
 * @property {string} backgroundColor - Set the full bleed background color
 * @property {object} image - Sets the  image
 * @property {string} tag - Sets the Tag
 * @property {string} eyebrow - Sets the eyebrow text
 * @property {string} headline  - Sets the headline  text
 * @property {string} headlineTag - Sets the headlineTag text
 * @property {string} headlineHighlight - Sets the headlineHighlight
 * @property {string} headlineHighlightColor - Sets the healineHighlightColor
 * @property {string} subheadline - Sets the subheadline
 * @property {object} actionGroup - Set the actionGroup
 */
export const propTypes =  {
  /** Set the full bleed background color. */
  backgroundColor: PropTypes.string,
  /** Sets the image for display */
  image: PropTypes.object,
  /** Set the eyebrow for display */
  eyebrow: PropTypes.string,
  /** Set the tag for display */
  tag: PropTypes.string,
  /** Set the headline for display */
  headline: PropTypes.string,
  /** Sets the headlineTag for display */
  headlineTag: PropTypes.string,
  /** Sets the headlineHighlight for display */
  headlineHighlight: PropTypes.string,
  /** Sets the headlineHighlightColor for display */
  headlineHighlightColor: PropTypes.string,
  /** Set the subheadline for display */
  subheadline: PropTypes.string,
  /** Set the action1 */
  actionGroup: PropTypes.object
};

DynamicTextOnlyHero.propTypes = propTypes;

export default DynamicTextOnlyHero;
